//  nativeBridge.js
//  Tulip Web Modules SDK
//
//  Tulip Web-to-Native Bridge Language Detector
//  © 2017 Tulip.
//


// - External Dependencies

import global from 'global';
import { get } from 'lodash';

// - Export

/// The Browser-Based Language-Detector Internationalization Extensions plugin used by SDK.I18n
/// allows for multiple detection strategies, including custom strategies.
/// https://github.com/i18next/i18next-browser-languageDetector#adding-own-detection-functionality
/// This custom detection functionality allows detection via the Tulip Web-to-Native Bridge context.
export default {
  name: 'nativeBridge',
  lookup() {
    get(global, 'tulipNativeBridge.context.locale', '').replace('_', '-');
  },
};



// WEBPACK FOOTER //
// ./src/i18n/detector/nativeBridge.js